import { createUseStyles } from 'react-jss'
import clsx from 'clsx'
import HTMLParse from 'react-html-parser'
import { mainAxios as axios } from '@/base/axios'
import BaseForm from '@/components/__form/BaseForm'
import { API, GF_CONSUMER_KEY, GF_CONSUMER_SECRET } from '@/constants'
import { convertJsontoFormData } from '@/utils/form'
import style from './style'

const useStyles = createUseStyles(style)

function ContactSection({ dispose, title, paragraph, form_title, form }) {
  const classes = useStyles()

  async function handleSendForm(sendData) {
    const token = `${GF_CONSUMER_KEY}:${GF_CONSUMER_SECRET}`
    const encodedToken = btoa(token)
    const headers = { 'Content-Type': 'multipart/form-data', Authorization: `Basic ${encodedToken}` }
    const response = await axios.post(
      `${API.GF_GET}/${form.id}/submissions`,
      convertJsontoFormData(sendData),
      { headers },
    )
    return response
  }

  return (
    <div className={classes.root}>
      <div className="container">
        <div className={clsx({
          grid: true,
          [classes.gridRow]: dispose === 'row',
          [classes.gridColumn]: dispose === 'column',
        })}
        >
          <div className={classes.detailsColLeft}>
            <h4>{HTMLParse(title)}</h4>
            <div className="p">{HTMLParse(paragraph)}</div>
          </div>
          <div className={classes.detailsColRight}>
            <h3>{HTMLParse(form_title)}</h3>
            {form?.fields?.length > 0 ? (
              <BaseForm
                fields={form.fields}
                submitLabel={form?.button?.text}
                sendContactForm={handleSendForm} // eslint-disable-line
                save={false}
                delayAfterReset={8000}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactSection
